import React, { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import LineChart from "./components/LineChart";
import BarChart from "./components/BarChart";
import LineChartMultiMarkets from "./components/LineChartMultiMarkets";
import ReactSelect from "react-select";
import yearlyData from "../prices/tableConvert.com_2p1qty.json";
import { dropdownStyles } from "../buy/buy";
import Client from "../../utils/client";
import LineChartMultiProducts from "./components/LineChartMultiProducts";

function Stats() {
  // console.log("Rendering Stats component");
  const [product, setProduct] = useState();
  const { data: prices } = useQuery({
    queryKey: ["prices"],
    queryFn: () => Client.get("/price").then((res) => res.data),
    initialData: [],
  });
  const data = useMemo(() => prices);

  const products = {};

  yearlyData.map((e) => (products[e["Product Ar"]] = e["Product Ar"]));

  const fake = [...yearlyData];

  function calculateAverageWithoutZeros(...prices) {
    const filteredPrices = prices.filter((price) => price !== 0);

    if (filteredPrices.length === 0) {
      return 0;
    }

    const sum = filteredPrices.reduce((total, price) => total + price, 0);
    return (sum / filteredPrices.length).toFixed(0);
  }

  const averagePrices = fake
    .filter((e) => e["Product Ar"] === (product ? product : "البرسيم الحجازي"))
    .map((product) => ({
      ...product,
      averagePrice: calculateAverageWithoutZeros(
        Number(product["Ad Damazin"]),
        Number(product["Al Foula"]),
        Number(product["Al Qadarif"]),
        Number(product["Dongola"]),
        Number(product["Ed Daein"]),
        Number(product["El Damer"]),
        Number(product["El Fasher"]),
        Number(product["El Nuhud"]),
        Number(product["El Obeid"]),
        Number(product["Geneina"]),
        Number(product["Kadugli"]),
        Number(product["Kassala"]),
        Number(product["Kosti"]),
        Number(product["Madani"]),
        Number(product["Nyala"]),
        Number(product["Om Durman"]),
        Number(product["Om Durman, El Salam"]),
        Number(product["Om Durman, Mowelih"]),
        Number(product["Port Sudan"]),
        Number(product["Rabak"]),
        Number(product["Singa"]),
        Number(product["Sinnar"]),
        Number(product["Zalingei"])
      ),
    }));

  const markets = prices?.map((e) => e.market);
  let uniqe = [...new Set(markets)];
  return (
    <div className="w-screen lg:w-full">
      <div className="w-full">
        <div className="justify-center overflow-hidden flex-col gap-3 px-3 mb-10 lg:flex-row-reverse w-full lg:gap-28 lg:my-9 flex ">
          <ReactSelect
            onChange={(e) => setProduct(e.value)}
            options={Object.keys(products).map((e) => {
              return { label: e, value: e };
            })}
            hideSelectedOptions={false}
            styles={dropdownStyles}
            closeMenuOnSelect={true}
            isRtl
            placeholder="المنتج"
            className="lg:w-[15rem]"
          />
          <div className="lg:w-[15rem] p-2 flex justify-center items-center border-secondary border rounded-[67px] ">
            {averagePrices[0]?.Unit} :الوحدة
          </div>
        </div>

        <div className="mx-2 bg-white lg:mx-auto h-[25rem]">
          <LineChart prices={averagePrices} />
        </div>
        <div className="mx-2 bg-white lg:mx-auto">
          <LineChartMultiMarkets />
        </div>

        <div className="mx-2 bg-white lg:mx-auto overflow-y-auto">
          <LineChartMultiProducts />
        </div>
      </div>
    </div>
  );
}

export default Stats;
